function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { Alias } from '../nodes/Alias.js';
import { isNode, isPair, MAP, SEQ, isDocument } from '../nodes/identity.js';
import { Scalar } from '../nodes/Scalar.js';
var defaultTagPrefix = 'tag:yaml.org,2002:';

function findTagObject(value, tagName, tags) {
  if (tagName) {
    var _match$find;

    var match = tags.filter(function (t) {
      return t.tag === tagName;
    });
    var tagObj = (_match$find = match.find(function (t) {
      return !t.format;
    })) !== null && _match$find !== void 0 ? _match$find : match[0];
    if (!tagObj) throw new Error("Tag ".concat(tagName, " not found"));
    return tagObj;
  }

  return tags.find(function (t) {
    var _t$identify;

    return ((_t$identify = t.identify) === null || _t$identify === void 0 ? void 0 : _t$identify.call(t, value)) && !t.format;
  });
}

function createNode(value, tagName, ctx) {
  var _tagName, _tagObj, _tagObj2, _tagObj2$nodeClass;

  if (isDocument(value)) value = value.contents;
  if (isNode(value)) return value;

  if (isPair(value)) {
    var _ctx$schema$MAP$creat, _ctx$schema$MAP;

    var map = (_ctx$schema$MAP$creat = (_ctx$schema$MAP = ctx.schema[MAP]).createNode) === null || _ctx$schema$MAP$creat === void 0 ? void 0 : _ctx$schema$MAP$creat.call(_ctx$schema$MAP, ctx.schema, null, ctx);
    map.items.push(value);
    return map;
  }

  if (value instanceof String || value instanceof Number || value instanceof Boolean || typeof BigInt !== 'undefined' && value instanceof BigInt // not supported everywhere
  ) {
    // https://tc39.es/ecma262/#sec-serializejsonproperty
    value = value.valueOf();
  }

  var aliasDuplicateObjects = ctx.aliasDuplicateObjects,
      onAnchor = ctx.onAnchor,
      onTagObj = ctx.onTagObj,
      schema = ctx.schema,
      sourceObjects = ctx.sourceObjects; // Detect duplicate references to the same object & use Alias nodes for all
  // after first. The `ref` wrapper allows for circular references to resolve.

  var ref = undefined;

  if (aliasDuplicateObjects && value && _typeof(value) === 'object') {
    ref = sourceObjects.get(value);

    if (ref) {
      if (!ref.anchor) ref.anchor = onAnchor(value);
      return new Alias(ref.anchor);
    } else {
      ref = {
        anchor: null,
        node: null
      };
      sourceObjects.set(value, ref);
    }
  }

  if ((_tagName = tagName) !== null && _tagName !== void 0 && _tagName.startsWith('!!')) tagName = defaultTagPrefix + tagName.slice(2);
  var tagObj = findTagObject(value, tagName, schema.tags);

  if (!tagObj) {
    if (value && typeof value.toJSON === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      value = value.toJSON();
    }

    if (!value || _typeof(value) !== 'object') {
      var _node = new Scalar(value);

      if (ref) ref.node = _node;
      return _node;
    }

    tagObj = value instanceof Map ? schema[MAP] : Symbol.iterator in Object(value) ? schema[SEQ] : schema[MAP];
  }

  if (onTagObj) {
    onTagObj(tagObj);
    delete ctx.onTagObj;
  }

  var node = (_tagObj = tagObj) !== null && _tagObj !== void 0 && _tagObj.createNode ? tagObj.createNode(ctx.schema, value, ctx) : typeof ((_tagObj2 = tagObj) === null || _tagObj2 === void 0 ? void 0 : (_tagObj2$nodeClass = _tagObj2.nodeClass) === null || _tagObj2$nodeClass === void 0 ? void 0 : _tagObj2$nodeClass.from) === 'function' ? tagObj.nodeClass.from(ctx.schema, value, ctx) : new Scalar(value);
  if (tagName) node.tag = tagName;else if (!tagObj.default) node.tag = tagObj.tag;
  if (ref) ref.node = node;
  return node;
}

export { createNode };